module.exports = "/assets/data/bbe1b145855d0ea306280b682bd3f910-BS99.data.json";